module.exports = __webpack_public_path__ + "static/media/mayaFoot.bc9f757a.png";